import type { Topic } from '@/types';

export const topics: Topic[] = [
  {
    slug: 'idol-watch',
    name: '顶流追踪',
    desc: '聚焦当红艺人的行程、合作与舆论风向，第一时间拆解热度背后的逻辑。',
    icon: 'ri-vip-crown-2-line',
  },
  {
    slug: 'film-tv',
    name: '影视内幕',
    desc: '从选角、改本到过审与排播，讲清楚一部剧从立项到上线的完整链条。',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'variety',
    name: '综艺现场',
    desc: '录制现场的真实流程、剪辑取舍与嘉宾互动，还原镜头之外的节目生态。',
    icon: 'ri-mic-2-line',
  },
  {
    slug: 'music',
    name: '音乐动态',
    desc: '发片节奏、舞台表现与版权分成，梳理华语音乐圈正在发生的变化。',
    icon: 'ri-music-2-line',
  },
  {
    slug: 'fashion',
    name: '时尚品牌',
    desc: '代言更替、造型团队与红毯博弈，看商业价值如何被一件高定重新定义。',
    icon: 'ri-handbag-line',
  },
  {
    slug: 'backstage',
    name: '幕后资本',
    desc: '工作室股权、平台分账与项目对赌，把娱乐产业背后的商业结构讲透。',
    icon: 'ri-line-chart-line',
  },
];

export const siteMeta = {
  name: '看瓜爆料',
  slogan: '别人挖不到的料，这里给你拆开讲透',
  intro:
    '看瓜爆料是一个专注娱乐行业动态与幕后信息的资讯门户，以独家、一手、内部首发为内容标准，为想比旁人先知道真相的读者提供有信息密度的深度爆料。',
  email: 'hi@kanguabaoliao.cn',
  since: '2019',
};

export const faqs = [
  {
    q: '看瓜爆料的独家内容是怎么来的？',
    a: '我们的稿件来自长期跟组的行业观察者、宣发从业者与内容编辑团队的交叉核实。每条爆料至少经过两次独立信源比对，无法确认的部分会明确标注为「待验证」，不会当作事实直接发布。',
  },
  {
    q: '为什么站内内容会使用「某顶流」「某热播剧主演」这样的写法？',
    a: '出于对当事人合法权益的尊重，在信息尚未公开或无法完全确认时，我们统一采用匿名化表述，只讨论事件本身的行业逻辑，不针对具体个人做定性判断。',
  },
  {
    q: '爆料信息多久更新一次？',
    a: '热榜每天上午更新一次，深度长文按选题节奏发布，通常每周三到五篇。遇到重大行业事件时，会开启临时加更。',
  },
  {
    q: '站内内容可以转载吗？',
    a: '欢迎在注明「来源：看瓜爆料」并保留原文链接的前提下转载摘要；如需整篇转载或商业使用，请通过页脚的邮箱联系我们获得授权。',
  },
  {
    q: '订阅之后会收到什么？',
    a: '每期一封邮件，包含当周最值得看的 3 条爆料和 1 个幕后观察。我们不会把你的邮箱用于其他用途，也不会向第三方共享。',
  },
];

export const testimonials = [
  {
    name: '林一桐',
    role: '影视宣传从业者',
    content: '写宣发方案前我会先刷一遍看瓜爆料的影视内幕栏目，他们对排播逻辑和过审节奏的梳理，比很多行业群里的消息还清楚。',
  },
  {
    name: '周执',
    role: '娱乐内容编辑',
    content: '很少见到把「独家」和「克制」这两件事同时做好的团队。该说的说透，不确定的直接标待验证，这点特别难得。',
  },
  {
    name: '陈默',
    role: '资深吃瓜用户',
    content: '热榜排序很真实，不是那种买了流量就往上顶的榜。每天上午刷一次，基本能把昨天圈里的大事补齐。',
  },
];